import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const ArrowLeft = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path
        d="M9.3 1.3L7.9 2.7 12.2 7 0 7 0 9 12.2 9 7.9 13.3 9.3 14.7 16 8z"
        transform="translate(-844 -1003) translate(844 1003) rotate(-180 8 8)"
      />
    </svg>
  );
};

ArrowLeft.displayName = 'ArrowLeft';
